import React, { useState } from 'react';

const FAQ = [
    {
        q: 'How do I disconnect HubSpot?',
        a: 'Go to Settings → Integrations → HubSpot and click the "Disconnect" button. This stops future syncs but does not delete leads already imported.',
    },
    {
        q: 'How do I disconnect Typeform?',
        a: 'Go to Settings → Integrations → Typeform and click "Disconnect". You will need to also remove the webhook from your Typeform account to stop new submissions from being sent.',
    },
    {
        q: 'How is my data secured?',
        a: 'All OAuth tokens and integration credentials are encrypted at rest using AES-256-GCM before being stored in our database. Data in transit is protected by TLS. We never store plaintext credentials.',
    },
    {
        q: 'How do I export my data?',
        a: 'On the Dashboard, sort and filter your leads as needed, then use your browser\'s print or save function. Full CSV export is on our roadmap. For a manual export in the meantime, contact support and we\'ll send you a CSV within 24 hours.',
    },
    {
        q: 'How does the free tier limit work?',
        a: 'Free accounts can score up to 50 leads per calendar month. The count resets on the 1st of each month. If you hit the limit, existing leads are unaffected — you just can\'t add new ones until the next month.',
    },
    {
        q: 'Why is my HubSpot sync showing an error?',
        a: 'Usually this means your HubSpot access token has expired or your permissions changed. Go to Settings → Integrations → HubSpot, click Reconnect, and complete the OAuth flow again.',
    },
    {
        q: 'How quickly does Typeform scoring happen?',
        a: 'Within a few seconds of a form submission arriving. The webhook fires immediately when a respondent submits, and Claude analysis runs asynchronously in the background.',
    },
];

function FaqItem({ q, a }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="border-b border-gray-100 last:border-0">
            <button
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between py-4 text-left gap-4"
            >
                <span className="text-sm font-medium text-gray-800">{q}</span>
                <span className="shrink-0 text-gray-400 text-lg leading-none">
                    {open ? '−' : '+'}
                </span>
            </button>
            {open && (
                <p className="pb-4 text-sm text-gray-600 leading-relaxed">{a}</p>
            )}
        </div>
    );
}

export default function Support() {
    return (
        <div className="max-w-3xl mx-auto px-4 py-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Support</h1>
            <p className="text-gray-500 mb-10">
                Need help? Email us at{' '}
                <a
                    href="mailto:support@lead-scoring-saas.com"
                    className="text-brand-500 hover:underline font-medium"
                >
                    support@lead-scoring-saas.com
                </a>{' '}
                and we'll get back to you within one business day.
            </p>

            <section>
                <h2 className="text-lg font-semibold text-gray-800 mb-4">Frequently Asked Questions</h2>
                <div className="rounded-xl border border-gray-200 bg-white px-5">
                    {FAQ.map((item) => (
                        <FaqItem key={item.q} q={item.q} a={item.a} />
                    ))}
                </div>
            </section>
        </div>
    );
}
